'use strict';

angular.module('kerp-forms.forms')
  .service('FCA_MAPPINGS', ['FormFieldMappings', 'addressFormatterService', 'objectUtils',
    function (FormFieldMappings, addressFormatterService, objectUtils) {

      this.mappings = function () {
        return FormFieldMappings
          .buildWithMappings({
            'person.details.title': 'title',
            'person.details.firstName': 'firstName',
            'person.details.lastName': 'lastName',
            'person.details.nationalInsuranceNumber': 'nationalInsuranceNumber',
            'person.details.phoneNumber': 'phoneNumber',
            'person.details.hasPartner': 'careAssessment.hasPartner',
            'person.details.dob': 'dateOfBirth',
            'person.details.address': 'address.formatted',

            'clientReference': 'careAssessment.clientReference',

            'person.details.declarePartnerFinances': 'careAssessment.declarePartnerFinances',
            'person.income.benefitsPaidAsCouple': 'careAssessment.benefitsPaidAsCouple',
            'person.income.isEntitledToCarersPremium': 'careAssessment.isEntitledToCarersPremium',

            'person.income.benefits.retirementPension': 'careAssessment.retirementPension.amount',
            'person.income.benefits.retirementPensionPeriod': 'careAssessment.retirementPension.frequency',

            'person.income.benefits.incapacityBenefit': 'careAssessment.incapacityBenefit.amount',
            'person.income.benefits.incapacityBenefitPeriod': 'careAssessment.incapacityBenefit.frequency',

            'person.income.benefits.warPension': 'careAssessment.warPension.amount',
            'person.income.benefits.warPensionPeriod': 'careAssessment.warPension.frequency',

            'person.income.benefits.warSpecialPayment': 'careAssessment.warSpecialPayment.amount',
            'person.income.benefits.warSpecialPaymentPeriod': 'careAssessment.warSpecialPayment.frequency',

            'person.income.benefits.childBenefit': 'careAssessment.childBenefit.amount',
            'person.income.benefits.childBenefitPeriod': 'careAssessment.childBenefit.frequency',

            'person.income.benefits.carersAllowance': 'careAssessment.carersAllowance.amount',
            'person.income.benefits.carersAllowancePeriod': 'careAssessment.carersAllowance.frequency',

            'person.income.benefits.pensionGuaranteeCredit': 'careAssessment.pensionGuaranteeCredit.amount',
            'person.income.benefits.pensionGuaranteeCreditPeriod': 'careAssessment.pensionGuaranteeCredit.frequency',

            'person.income.benefits.pensionSavingsCredit': 'careAssessment.pensionSavingsCredit.amount',
            'person.income.benefits.pensionSavingsCreditPeriod': 'careAssessment.pensionSavingsCredit.frequency',

            'person.income.benefits.attendanceAllowance': 'careAssessment.attendanceAllowance',
            'person.income.benefits.mobilityAllowance': 'careAssessment.mobilityAllowance',

            'person.income.hasUniversalCredit': 'careAssessment.hasUniversalCredit',
            'person.income.universalCredit.standardAllowance': 'careAssessment.universalCreditAllowances.standardAllowance',
            'person.income.universalCredit.housingElement': 'careAssessment.universalCreditAllowances.housingElement',
            'person.income.universalCredit.children': 'careAssessment.universalCreditAllowances.children',
            'person.income.universalCredit.disabledChild': 'careAssessment.universalCreditAllowances.disabledChild',
            'person.income.universalCredit.childcare': 'careAssessment.universalCreditAllowances.childcare',
            'person.income.universalCredit.carer': 'careAssessment.universalCreditAllowances.carer',
            'person.income.universalCredit.limitedWorkCapability': 'careAssessment.universalCreditAllowances.limitedWorkCapability',
            'person.income.universalCredit.limitedWorkAndRelatedCapability': 'careAssessment.universalCreditAllowances.limitedWorkAndRelatedCapability',
            'person.income.universalCredit.other': 'careAssessment.universalCreditAllowances.other',
            'person.income.universalCredit.earnings': 'careAssessment.universalCreditAllowances.earnings',
            'person.income.universalCredit.capitalTariff': 'careAssessment.universalCreditAllowances.capitalTariff',
            'person.income.universalCredit.debts': 'careAssessment.universalCreditAllowances.debts',

            'person.expenses.councilTax': 'careAssessment.councilTax',

            'person.expenses.compulsoryPayments': 'careAssessment.compulsoryPayments.amount',
            'person.expenses.compulsoryPaymentsPeriod': 'careAssessment.compulsoryPayments.frequency',

            'person.expenses.rent': 'careAssessment.rent.amount',
            'person.expenses.rentPeriod': 'careAssessment.rent.frequency',

            'person.expenses.mortgage': 'careAssessment.mortgage.amount',
            'person.expenses.mortgagePeriod': 'careAssessment.mortgage.frequency',

            'person.expenses.waterRates': 'careAssessment.waterRates.amount',
            'person.expenses.waterRatesPeriod': 'careAssessment.waterRates.frequency',

            'person.expenses.homeContentsInsurance': 'careAssessment.homeContentsInsurance.amount',
            'person.expenses.homeContentsInsurancePeriod': 'careAssessment.homeContentsInsurance.frequency',

            'person.expenses.groundRent': 'careAssessment.groundRent.amount',
            'person.expenses.groundRentPeriod': 'careAssessment.groundRent.frequency',

            'partner.income.benefits.retirementPension': 'careAssessment.partner.retirementPension.amount',
            'partner.income.benefits.retirementPensionPeriod': 'careAssessment.partner.retirementPension.frequency',

            'partner.income.benefits.incapacityBenefit': 'careAssessment.partner.incapacityBenefit.amount',
            'partner.income.benefits.incapacityBenefitPeriod': 'careAssessment.partner.incapacityBenefit.frequency',

            'partner.income.benefits.warPension': 'careAssessment.partner.warPension.amount',
            'partner.income.benefits.warPensionPeriod': 'careAssessment.partner.warPension.frequency',

            'partner.income.benefits.warSpecialPayment': 'careAssessment.partner.warSpecialPayment.amount',
            'partner.income.benefits.warSpecialPaymentPeriod': 'careAssessment.partner.warSpecialPayment.frequency',

            'partner.income.benefits.childBenefit': 'careAssessment.partner.childBenefit.amount',
            'partner.income.benefits.childBenefitPeriod': 'careAssessment.partner.childBenefit.frequency',

            'partner.income.benefits.carersAllowance': 'careAssessment.partner.carersAllowance.amount',
            'partner.income.benefits.carersAllowancePeriod': 'careAssessment.partner.carersAllowance.frequency',

            'partner.income.benefits.attendanceAllowance': 'careAssessment.partner.attendanceAllowance',
            'partner.income.benefits.mobilityAllowance': 'careAssessment.partner.mobilityAllowance',

            'partner.details.dob': 'careAssessment.partner.dateOfBirth'
          })
          .factToFieldConverters({
            'partner.details.dob': function (facts) {
              var dateOfBirth = objectUtils.getPropertyPath(facts, 'careAssessment.partner.dateOfBirth');

              if (dateOfBirth) {
                return this.ISOStringToDDMMYYYY(dateOfBirth);
              }
            },

            'person.details.dob': function (facts) {
              return this.ISOStringToDDMMYYYY(facts.dateOfBirth);
            },

            // We don't map the formatted (string) address fact to the address form fields because there's no reliable
            // way to convert a comma-delimited address string into an address object with separate properties for
            // line1, line2, postcode, etc.
            //
            // We also don't want to map the address (object) fact to the address form fields, because the UPRN is not
            // included in the former.
            'person.details.address': function (facts) {
              return null;
            }
          })
          .fieldToFactConverters({
            'careAssessment.partner.dateOfBirth': function (model) {
              var dateOfBirth = objectUtils.getPropertyPath(model, 'partner.details.dob');

              if (dateOfBirth) {
                return this.DDMMYYYYToISOString(dateOfBirth);
              }
            },
            dateOfBirth: function (model) {
              var dateOfBirth = objectUtils.getPropertyPath(model, 'person.details.dob');
              return this.DDMMYYYYToISOString(dateOfBirth);
            },
            'address.formatted': function (model) {
              var addressParts = objectUtils.getPropertyPath(model, 'person.details.address');
              if (!addressParts) {
                return null;
              }
              return addressFormatterService.formatAsString(
                [addressParts.line1, addressParts.line2, addressParts.line3, addressParts.postcode]);
            }
          });
      };
    }]);
